import { useNavigate } from "react-router-dom";

import { HStack } from "@/components/layout";
import Stats from "@/components/stats";
import { Button } from "@headlessui/react";
import { useParams } from "react-router-dom";

const ProcessModal = ({ isOpen, onClose, projectDetails = {} }) => {
  const navigate = useNavigate();
  const { projectSlug } = useParams();
  if (!isOpen) return null;

  const processProject = [
    {
      label: "Total # of statement pages",
      value: projectDetails.numberOfPages,
    },
    {
      label: "Pages remaining in your plan",
      value: projectDetails.pagesRemaining || 0,
    },
    {
      label: "Pages remaining after processing",
      value: projectDetails.pagesAfterProcessing || 0,
    },
    {
      label: "Cost to process this project",
      value: `$${projectDetails.cost || 0}`,
    },
  ];

  const handleProcess = () => {
    navigate(`/${projectSlug}/processed`);
  };

  return (
    <HStack className="fixed inset-0 z-50 justify-center bg-black bg-opacity-20">
      <div className="mt-44 w-full max-w-lg rounded-lg bg-white p-7">
        <h2 className="mb-4 text-xl font-semibold">
          Let`s get ready to process
        </h2>
        <p className="text-cp-body mb-7 text-base">
          Once you process this project, you will be unable to make changes,
          like adding or removing files. Make sure you`ve added all your PDFs
          before continuing. You can always create additional projects to
          process files.
        </p>
        <div className="mb-7 space-y-4 text-sm">
          <Stats items={processProject} />
        </div>
        <div className="flex justify-end">
          <Button
            className="mr-2 rounded bg-white px-4 py-2 text-black hover:bg-gray-400"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="rounded bg-black px-4 py-2 text-white"
            onClick={handleProcess}
          >
            Process project
          </Button>
        </div>
      </div>
    </HStack>
  );
};

export default ProcessModal;
